/**
 * @description Object containing all request endpoints
 */
export const API_ROUTES = {
  AUTH: {
    SESSION: () => `api/auth/session`,
    SWITCH: () => `api/auth/switch`,
    ACCEPT_TERMS: () => `api/auth/accept-terms`,
  },
  ACCOUNT_GROUPS: {
    LIST: () => `api/account-groups`,
    CANDIDATES: () => `api/account-groups/candidates`,
    DETAIL: (id: string) => `api/account-groups/${id}`,
  },
  ORGANIZATION_DOMAINS: {
    LIST: () => `api/organization-domains`,
    CANDIDATES: () => `api/organization-domains/candidates`,
    DETAIL: (id: string) => `api/organization-domains/${id}`,
  },
  HOSPITAL_COMPETITION: {
    LIST: (range?: string) =>
      `api/hospital-competition${range ? `?range=${encodeURIComponent(range)}` : ""}`,
  },
  ORGANIZATIONS: {
    STRUGGLING_LEARNERS: (orgId: string, studentId?: string) =>
      `api/organizations/${orgId}/struggling-learners${
        studentId ? `?studentId=${encodeURIComponent(studentId)}` : ""
      }`,
    STRUGGLING_LEARNER_COMPARISON: (orgId: string, studentId: string) =>
      `api/organizations/${orgId}/struggling-learners/${encodeURIComponent(studentId)}`,
  },
  EDUCATION_RECORD_ACCESS_LOG: {
    RECORD: () => `api/education-record-access-log`,
    LIST: (params?: {
      orgId?: string;
      q?: string;
      action?: string;
      limit?: number;
      offset?: number;
    }) => {
      const search = new URLSearchParams();
      if (params?.orgId) search.set("orgId", params.orgId);
      if (params?.q) search.set("q", params.q);
      if (params?.action) search.set("action", params.action);
      if (params?.limit != null) search.set("limit", String(params.limit));
      if (params?.offset != null) search.set("offset", String(params.offset));
      const qs = search.toString();
      return `api/education-record-access-log${qs ? `?${qs}` : ""}`;
    },
  },
  ME: {
    ACCOUNTS: () => `api/me/accounts`,
  },
  USERS: {
    DELETE: (email: string) => `api/users/${email}/`,
    UPDATE: (id: string) => `api/users/${id}/`,
    MISSING_COGNITO: () => `api/users/missing-cognito`,
    MISSING_COGNITO_ATTRIBUTES: () => `api/users/missing-cognito-attributes`,
    SYNC_COGNITO_ATTRIBUTES: () => `api/users/sync-cognito-attributes`,
    EDUCATION_RECORDS_EXPORT: (userId: string) =>
      `api/users/${userId}/education-records/export`,
    EDUCATION_RECORDS_DISCLOSURE: (userId: string) =>
      `api/users/${userId}/education-records/disclosures`,
  },
  FILES: {
    UPLOAD: () => `api/files/upload`,
  },
  AI: {
    REQUIREMENTS_FROM_SPREADSHEET: () =>
      `api/ai/requirements/from-spreadsheet`,
    REQUIREMENTS_REVIEW_SPREADSHEET: () =>
      `api/ai/requirements/review-spreadsheet`,
  },
  ALERT: {
    SEND_ALERT: () => `api/alert/send`,
  },
  FEEDBACK_AMENDMENT_REQUESTS: {
    NOTIFY: (id: string) => `api/feedback-amendment-requests/${id}/notify`,
    DECIDE: (id: string) => `api/feedback-amendment-requests/${id}/decision`,
  },
  POSTS: {
    NOTIFY: (postId: string) => `api/posts/${postId}/notify`,
  },
  REALTIME: {
    NOTIFY: () => `api/realtime/notify`,
  },
};
